<script setup lang="ts">
import { DropdownMenuPortal, useForwardPropsEmits } from 'radix-vue'
import type { DropdownMenuPortalProps } from 'radix-vue'

const props = defineProps<DropdownMenuPortalProps>()

const forwarded = useForwardPropsEmits(props)
</script>

<template>
  <DropdownMenuPortal v-bind="forwarded">
    <slot />
  </DropdownMenuPortal>
</template>
